export const messages = {
  en: {
    listApplyRoomDiscountRecordDetails: {
      title: 'Decoration Records',
      back: 'Back',
      room: 'Room',
      image: 'Image/Video',
      createTime: 'Create Time',
      page: {
        title: 'Decoration Records',
        subtitle: 'View the images and videos submitted for this room renovation application',
        empty: 'No decoration records found',
        loadFailed: 'Failed to load decoration records, please retry',
        tip: 'Click an image to preview it in full size'
      }
    }
  },
  zh: {
    listApplyRoomDiscountRecordDetails: {
      title: '装修记录',
      back: '返回',
      room: '房屋',
      image: '图片/视频',
      createTime: '创建时间',
      page: {
        title: '装修记录',
        subtitle: '查看该房屋装修申请提交的图片与视频材料',
        empty: '暂无装修记录',
        loadFailed: '装修记录加载失败，请重试',
        tip: '点击图片可放大预览'
      }
    }
  }
}
